import { apiFetch} from "apiClient";
import { apiFetch as fetch } from "apiClient";


export const fetchGUIInstrumentsByTabID = async (tabID) => {
    try {
        const res  = await fetch(`/api/gui-instruments/get-instruments-for-the-grid/${encodeURIComponent(tabID)}`);
        const data = await res.json();
        return Array.isArray(data) ? data : [];
    } catch (error) {
        console.error(`Error fetching instruments for tabID ${tabID}:`, error);
        return [];
    }
};

